<template>
	<div class="section_title_sticky px-2 sticky top-0 z-10" :class="{'!max-w-full': isDesktopVersion()}" id="#sticky-navbar">
		<div class="overflow-hidden w-full in--section_title">
			<div class="w-full h-16 absolute z-20" v-if="!click"></div>
			<div class="overflow-scroll scroll" id="scroll-navbar" v-dragscroll
				v-on:dragscrollstart="startDragScroll"
				v-on:dragscrollend="endDragScroll">
				<div @click="manuallyLeft()" v-if="displayBtnManullyLeft" class="scroll-btn cursor-pointer absolute w-10 h-10 flex items-center justify-center z-40 mt-2  rounded-full text-transparent bg-transparent border border-transparent">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
				</div>
				<div class="flex relative" id="scroll-navbar-flex">
					<div v-for="item in sections" :key="item.id" class="cursor-pointer scroll-navbar-item" :id="'topmenu-item_' + item.id">
						<div @click="scrollToComponent(item.id, !click)" class="overflow-hidden relative whitespace-no-wrap inline-block text-sm rounded-full px-2">
							<span class="nav-active absolute"></span>
							<span class="z-10 relative nav-text" :class="pickTextColorBasedOnBgColorSimple($root.hotelColor())">{{ $root.getLangText(item.title) }}</span>
						</div>
					</div>
				</div>
				<div @click="manuallyRight()" v-if="displayBtnManullyRight" class="scroll-btn cursor-pointer right-0 top-0 absolute w-10 h-10 flex items-center justify-center z-40 mt-4 rounded-full text-transparent bg-transparent border border-transparent">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { dragscroll } from 'vue-dragscroll';

    export default {
		props: {
			sections: {},
		},

        directives: {
            dragscroll
        },

        data() {
            return {
                click: true,
				scrolling: false,
				displayBtnManullyLeft: false,
				displayBtnManullyRight: true,
            }
        },

        created () {
			this.$nextTick(() => {
				if (document.querySelectorAll('.wrapper .content_products').length > 0) {
					this.activeNav(document.querySelectorAll('.wrapper .content_products')[0].getAttribute('data-navbarid'));
				}
			});

            window.addEventListener('scroll', this.handleScroll);
        },

        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },

        methods: {
            startDragScroll() {
                let $this = this;
                setTimeout(function () {
                    $this.click = false;
                }, 100);
			},

            endDragScroll() {
				let $this = this;
				setTimeout(function () {
					$this.click = true;
				}, 100);
            },

            handleScroll (event) {
				var headerFly = document.querySelector('#header-fly');
				var headerFlyBackButton = document.querySelector('#homeBackButton');
				var headerFlySelectLanguageButton = document.querySelector('#btn-select-language');
				var headerFlyTitle = document.querySelector('#header-title');

				if (event.currentTarget.scrollY > 140) {
					headerFly.classList.add('bg-white');
					headerFly.classList.add('p-2');
					headerFly.classList.remove('p-4');
					
					headerFlyBackButton.classList.remove('shadow');
					headerFlySelectLanguageButton.classList.remove('shadow');
					headerFlyTitle.classList.remove('hidden');
				} else {
					headerFly.classList.remove('bg-white');
					headerFly.classList.remove('p-2');
					headerFly.classList.add('p-4');

					headerFlyBackButton.classList.add('shadow');
					headerFlySelectLanguageButton.classList.add('shadow');
					headerFlyTitle.classList.add('hidden');
				}
					
				var activeElement = null;
				document.querySelectorAll('.wrapper .content_products').forEach((element) => {				
					if (activeElement === null) {
						if (this.checkInView(element)) {
							activeElement = element.getAttribute('data-navbarid');
						}
					}
				});				


				this.activeNav(activeElement);		
            },

			activeNav(activeElement) {
				if (activeElement === null)
					return false;
				
				let topmenuid = '#' + activeElement;

				let scrollNavActive = document.querySelectorAll('.scroll-navbar-item.active');
				scrollNavActive.forEach((element) => {
					element.classList.remove('active');
				})
				document.querySelector(topmenuid).classList.add('active');

				let parent = document.querySelector('#scroll-navbar');
				let parent_child = document.querySelector(topmenuid);
				parent.scrollLeft = parent_child.offsetLeft;			
			},


			checkInView(el) {
				//Get container properties
				var top = el.offsetTop - 130;
				var left = el.offsetLeft;
				var width = el.offsetWidth;
				var height = el.offsetHeight;

				while(el.offsetParent) {
					el = el.offsetParent;
					top += el.offsetTop;
					left += el.offsetLeft;
				}

				return (
					top < (window.pageYOffset + window.innerHeight) &&
					left < (window.pageXOffset + window.innerWidth) &&
					(top + height) > window.pageYOffset &&
					(left + width) > window.pageXOffset
				);
			},

			pickTextColorBasedOnBgColorSimple(bgColor) {
				var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
				var r = parseInt(color.substring(0, 2), 16); // hexToR
				var g = parseInt(color.substring(2, 4), 16); // hexToG
				var b = parseInt(color.substring(4, 6), 16); // hexToB
				return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
					'text-gray-800' : 'text-active-white';
			},

			manuallyLeft() {
				document.querySelector('#scroll-navbar').scrollLeft = 
				document.querySelector('#scroll-navbar').scrollLeft - 100;

				if (document.querySelector('#scroll-navbar').scrollLeft <= 0) {
					this.displayBtnManullyLeft = false;
				}

				this.displayBtnManullyRight = true;
			},

			manuallyRight() {				
				document.querySelector('#scroll-navbar').scrollLeft = 
				document.querySelector('#scroll-navbar').scrollLeft + 100;

				let list = document.querySelectorAll(".scroll-navbar-item");
				var summ = 0;
				Array.from(list).map(elem => {
					summ += elem.clientWidth;
				});

				var maxSum = 500;
				if (!this.$root.isMobile())
					maxSum = 700;

				if (document.querySelector('#scroll-navbar').scrollLeft > summ - maxSum) {
					this.displayBtnManullyRight = false;
				}

				this.displayBtnManullyLeft = true;
			},

            scrollToComponent(key, scroll) {
                if (scroll)
                    return;
                //e.stopPropagation()			
                let parent = document.querySelector('#scroll-navbar');
                let parent_child = document.querySelector('#topmenu-item_' + key);
                parent.scrollLeft = parent_child.offsetLeft;

                this.$scrollTo('#section_' + key, 1, {
					container: 'body',
                    easing: 'linear',
                    offset: -120,
                    force: true,
                    cancelable: true,
                    x: false,
                    y: true
				});
            },
		},
    }
</script>

<style>
	.section_title_sticky {
		/*position: fixed;*/
		background:#fff;
		z-index: 35;
		font-style: normal;
		font-weight: normal;
		font-size: 20px;
		line-height: 55px;
		align-items: center;
		text-align: center;
		width: 100%;
		/*left: 50%;
		transform: translate(-50%, 0);
		/*display: none;*/
		top: 40px;
		/*box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.05);*/
	}


	.section_title_sticky.can-sticky-or-not.not-sticky {
		display: block;
		position: relative;
		top: 0;
		box-shadow: 0 0 0;
		margin-top: 10px;
	}


	@media (min-width: 450px) and (max-width: 991px) {
		.section_title_sticky {
			max-width: 450px;
		}
	}

	@media (min-width: 950px) {
		.section_title_sticky {
			top: 55px;
		}
	}

	#sticky-navbar.active {
		display: flex;
	}

	.in--section_title {
		height: 60px; 
		padding-top: 7px;
	}

	.scroll-navbar-item.active .nav-active{
		border-radius: 20px;
		background: red;
		padding: 10px;
		color: #fff;
		top: 13px;
		left: 0;
		width: 100%;
		height: 28px;
		background: var(--main-color);
		-webkit-box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
		box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
	}

	.scroll-navbar-item.active .text-active-white {
		color: #ffffff;
	}


	.scroll:hover .scroll-btn {
		background: #ffffff;
		border: 1px solid #cbd5e0;
		color: #4a5568;
		box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
	}

</style>